
import { WebhookEvent } from "./eventUtils";
import { WebhookEventRow } from "./WebhookEventRow";

interface WebhookEventsTableProps {
  events: WebhookEvent[];
}

export const WebhookEventsTable = ({ events }: WebhookEventsTableProps) => {
  if (events.length === 0) {
    return (
      <div className="mt-4 p-6 bg-gray-50 rounded-md text-center text-gray-500">
        No webhook events found. Events will appear here when they are received.
      </div>
    );
  }

  return (
    <div className="mt-4 overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
            <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Phone</th>
            <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
            <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {events.map((event) => (
            <WebhookEventRow key={event.id} event={event} />
          ))}
        </tbody>
      </table>
    </div>
  );
};
